import { uploadBaseModel } from './crud';

export * from './types';

export const useUploadsById = uploadBaseModel.fetchById();
export const useUploadsByIds = uploadBaseModel.fetchByIds();
export const useUploadsMany = uploadBaseModel.fetchMany();
export const useUploadsCount = uploadBaseModel.count();
export const useUploadsManyInfiniteQuery = uploadBaseModel.fetchPaginated();
export const useUploadsUpdateOne = uploadBaseModel.edit();
export const useUploadsCreateOne = uploadBaseModel.create();
export const useUploadsRemoveOne = uploadBaseModel.delete();
export const useUploadsRemoveByIds = uploadBaseModel.deleteByIds();

export const useUploadsByIdV2 = uploadBaseModel.fetchByIdV2();
export const useUploadsByIdsV2 = uploadBaseModel.fetchByIdsV2();
export const useUploadsManyV2 = uploadBaseModel.fetchManyV2();
export const useUploadsCountV2 = uploadBaseModel.countV2();
export const useUploadsManyInfiniteQueryV2 = uploadBaseModel.fetchPaginatedV2();
export const useUploadsUpdateOneV2 = uploadBaseModel.editV2();
export const useUploadsCreateOneV2 = uploadBaseModel.createV2();
export const useUploadsRemoveOneV2 = uploadBaseModel.deleteV2();
export const useUploadsRemoveByIdsV2 = uploadBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useUploadById = uploadBaseModel.fetchById();
export const useUploadByIds = uploadBaseModel.fetchByIds();
export const useUploadMany = uploadBaseModel.fetchMany();
export const useUploadCount = uploadBaseModel.count();
export const useUploadPagination = uploadBaseModel.fetchPaginated();
export const useUploadUpdateOne = uploadBaseModel.edit();
export const useUploadCreateOne = uploadBaseModel.create();
export const useUploadRemoveOne = uploadBaseModel.delete();
export const useUploadRemoveByIds = uploadBaseModel.deleteByIds();

export const useUploadByIdV2 = uploadBaseModel.fetchByIdV2();
export const useUploadByIdsV2 = uploadBaseModel.fetchByIdsV2();
export const useUploadManyV2 = uploadBaseModel.fetchManyV2();
export const useUploadCountV2 = uploadBaseModel.countV2();
export const useUploadPaginationV2 = uploadBaseModel.fetchPaginatedV2();
export const useUploadUpdateOneV2 = uploadBaseModel.editV2();
export const useUploadCreateOneV2 = uploadBaseModel.createV2();
export const useUploadRemoveOneV2 = uploadBaseModel.deleteV2();
export const useUploadRemoveByIdsV2 = uploadBaseModel.deleteByIdsV2();
